module.exports = __webpack_public_path__ + "img/icon_for_my_object.0f85031f.webp";